import { ref } from 'vue';
import { oneProviderAPI } from '@/laravel/config';
// import { OPID } from '@/laravel/config'; comes with the url for posts

const getItems = async (table) => {
    const res = ref(null);
    const err = ref(null);

    // start
    try {
        const response = await fetch(oneProviderAPI + `/${table}`);
        if (!response.ok) {
            throw new Error(`Network response was not OK: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        res.value = data;
    } catch (error) {
        err.value = error.message;
    }

    return { res, err };
};

export default getItems;